module.exports = __webpack_public_path__ + "img/shape-top.73cf08e5.png";